import styled from 'styled-components';
import {Tabs} from 'react-bootstrap';
import {getContrastWhiteBlack} from '../../../utils/helpers';

const StyledTabs = styled(Tabs)`
    .nav.nav-justified > li > a {
        padding: 10px 5px;
    }
    .tab-content {
        margin-top: 10px;
    }
    li.active .badge {
        color: ${props => props.theme.brandColor};
        background-color: ${props => props.theme.brandContrast};
    }
    .nav-pills a {
        color: ${props => props.theme.textColor};
    }
    .nav-pills > li.active > a {
        color: ${props => props.theme.brandContrast};    
        background-color: ${props => props.theme.brandColor};
    }
    li .badge {
        color: ${props => props.theme.brandContrast};
        background-color: ${props => props.theme.brandColor};        
    } 
    
    .badgeActive {
        color: ${props => props.theme.brandColor};
        background-color: ${props => props.theme.brandContrast};
    }
    .nav > li > a:hover, .nav > li > a:focus {
        background-color: ${props => props.theme.hoverColor};    
        color:${props => getContrastWhiteBlack(props.theme.hoverColor) };
    }
    .nav > li > a:hover {
        background-color: ${props => props.theme.hoverColor};    
        color:${props => getContrastWhiteBlack(props.theme.hoverColor) };
        .badge {
            color:${props => getContrastWhiteBlack(getContrastWhiteBlack(props.theme.hoverColor))};
            background-color: ${props => getContrastWhiteBlack(props.theme.hoverColor) };
        }
    }
    
    .nav > li.active > a:hover, .nav > li.active > a:focus {
        background-color: ${props => props.theme.brandColor};
        color:${props => getContrastWhiteBlack(props.theme.brandColor) };
    }
    
    .nav > li.active > a:hover {
         .badge {
            color:${props => props.theme.brandColor};
            background-color: ${props => getContrastWhiteBlack(props.theme.brandColor) };
        }
    }
    
    /* TODO: extract all from down here, it's not relevant for all tabs, maybe in scoreboard */
    .listItemsWrapper, .requestListItem {
        border: 1px solid ${props => props.theme.borderColor};
    }
    .requestListItem {
        border-radius: 7px;
        padding: 15px;
        margin-bottom: 10px;
        color: ${props => props.theme.textColor};
  }  
    .requestListItem:hover {
        background-color: ${props => props.theme.hoverColor};
        color:${props => getContrastWhiteBlack(props.theme.hoverColor) };
    }
    .requestListItemMoreDetails {
        border-color: ${props => props.theme.brandColor};
    }
`;

export default StyledTabs;



// WEBPACK FOOTER //
// ./components/utils/Styled/tabs.js